var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M5.95 10.526c-2.509 0-4.55-2.046-4.55-4.561s2.041-4.561 4.55-4.561 4.55 2.046 4.55 4.56c0 2.516-2.041 4.562-4.55 4.562zm4.794-1.043c.723-.988 1.156-2.202 1.156-3.518C11.9 2.675 9.23 0 5.95 0 2.67 0 0 2.676 0 5.965c0 3.289 2.67 5.965 5.95 5.965 1.464 0 2.804-.536 3.84-1.418l2.463 2.468c.136.136.316.205.495.205s.358-.069.495-.205c.273-.275.273-.718 0-.993l-2.499-2.504z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.98a87ec684c633310f3f46d8360fb4f1.svg";
export { ForwardRef as ReactComponent };